export default "__VITE_ASSET__BzFB7Z8Z__"